/*
 * action types
 */
export const GET_WARNING_REQUEST = "GET_WARNING_REQUEST";
export const UPDATE_WARNING_REQUEST = "UPDATE_WARNING_REQUEST";
export const GET_WARNING_STATUS = "GET_WARNING_STATUS";

/*
 * action creators
 */
export const getWarningRequest = showWarningStatus => ({
  type: GET_WARNING_REQUEST,
  showWarningStatus
});
export const updateWarningRequest = showWarning => ({
  type: UPDATE_WARNING_REQUEST,
  showWarning
});
export const getWarningStatus = warningStatus => ({
  type: GET_WARNING_STATUS,
  warningStatus
});



// WEBPACK FOOTER //
// ./src/actions/warning.js